<form id="llmConfigurationForm" [formGroup]="llmConfigurationForm" (submit)="onSubmitForm()">
  <ca-compact-form-body>
    <ng-template form-row>
      <div class="col-4">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="name">
            {{ '::Name' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="name" formControlName="name" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="llmProviderId">
            {{ 'Settings::LLMConfiguration:Provider' | abpLocalization }}
          </ca-form-label>
          <ca-select
            [class]="'below-all'"
            id="llmProviderId"
            formControlName="llmProviderId"
            [disabled]="llmConfiguration?.id > 0"
            (change)="onProviderChange($event)">
            <ca-option *ngFor="let llmProvider of llmProviders" [value]="llmProvider.id">
              {{ 'GenericLookup::' + llmProvider.code | abpLocalization }}
            </ca-option>
          </ca-select>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <div class="col-4" *ngIf="isOpenAIProvider || isAzureProvider">
        <ca-compact-form-item>
          <ca-form-label
            [ngClass]="llmConfiguration?.id === 0 ? 'indicates-required-field' : ''"
            for="apiKey">
            {{ 'Settings::LLMConfiguration:APIKey' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input
              type="password"
              class="form-control form-control-sm"
              id="apiKey"
              formControlName="apiKey"
              [placeholder]="
                llmConfiguration?.id > 0
                  ? ('Settings::MaskedAreaPlaceholder' | abpLocalization)
                  : ''
              " />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isOpenAIProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="generativeAIModel">
            {{ 'Settings::LLMConfiguration:OpenAIModel' | abpLocalization }}
          </ca-form-label>
          <ca-select
            [class]="'below-all'"
            formControlName="generativeAIModel"
            id="generativeAIModel">
            <ca-option *ngFor="let openAIModel of openAIModels" [value]="openAIModel">
              {{ openAIModel }}
            </ca-option>
          </ca-select>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isAzureProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="resourceName">
            {{ 'Settings::LLMConfiguration:APIBase' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="resourceName" formControlName="resourceName" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isAzureProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="deploymentName">
            {{ 'Settings::LLMConfiguration:DeploymentName' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="deploymentName" formControlName="deploymentName" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <div class="col-4" *ngIf="isAzureProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="apiVersion">
            {{ 'Settings::LLMConfiguration:APIVersion' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="apiVersion" formControlName="apiVersion" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <ca-compact-form-spacer></ca-compact-form-spacer>
    </ng-template>
  </ca-compact-form-body>
  <ca-compact-form-footer
    [processing]="processing"
    [buttons]="formButtonConfiguration"
    [processingMessage]="processingMessage"
    (deleteButtonClick)="confirmDeletion($event, llmConfiguration.name)"
    (cancelButtonClick)="closePanel()"></ca-compact-form-footer>
</form>
